export default {
	//...uk,
	langname: "Українська",
	language: "мова",
	homepage: "Головна",
	profile: "Профіль",
	log: "лог",

	boolean: "логічне значення",
	int: "ціле число",
	float: "число",
	datetime: "дата та час",
	string: "текст",

	commonAttributes: "загальні атрибути",
	type: "тип",
	types: "типи",
	name: "назва",
	namePersonOrganisation: "П.І.Б. /Назва організації",
	number: "номер",
	date: "дата",
	from: "з",
	to: "по",
	yes: "так",
	not: "ні",
	error: "помилка",

	commonActions: "загальні дії",
	actions: "Дії",
	enter: "Увійти",
	entry: "Вхід",
	exit: "Вихід",
	ok: "OK",
	cancel: "Скасувати",
	confirm: "підтвердити",
	agree: "згоден",
	disagree: "не згоден",
	add: "Додати",
	remove: "Видалити",
	preview: "перегляд",
	clear: "Очистити",
	new: "Створити",
	edit: "Редагувати",
	create: "Створити",
	update: "Редагувати",
	delete: "Видалити",
	search: "пошук",
	moveup: "змістити вверх",
	movedown: "змістити вниз",
	moveleft: "змістити ліворуч",
	moveright: "змістити праворуч",
	login: "логін",
	signin: "Вхід",
	signup: "Реєстрація",
	save: "Зберегти",
	open: "відкрити",
	close: "закрити",
	cut: "вирізати",
	copy: "копіювати",
	duplicate: "дублікат",
	paste: "вставити",
	refresh: "оновити",
	export: "експорт",
	import: "імпорт",
	dict: "довідник",
	authorization: "авторизація",
	registration: "реєстрація",
	createaccount: "Створити Аккаунт",
	password: "пароль",
	passwordold: "старий пароль",
	passwordnew: "новий пароль",
	passwordconfirm: "підтвердити пароль",
	passwordchange: "змінити пароль",
	passwordreset: "Оновлення паролю",
	passwordrecovery: "Відновлення паролю",
	passwordforgot: "Забули пароль?",
	donthaveaccount: "Створити Аккаунт",
	orderconnection: "Заявка на підключення",
	expand: "розгорнути",
	collapse: "згорнути",

	// Objects
	main: "головна",
	account:"обліковий запис",
	accounts:"облікові записи",
	bot:"бот",
	bots:"боти",
	command:"команда",
	commands:"команди",
	users: "користувачі",
	user: "користувач",
	roles: "Ролі",
	role: "Роль",
	scenarium: "сценарій",
	scenariums: "сценарії",
	chat: "чат",
	chats: "чати",
	talk: "розмова",
	talks: "розмови",
	gallery: "галерея",
	message: "повідомлення",
	messages: "повідомлення",
	request: "запит",
	requests: "запити",
	respond: "відповідь",
	responds: "відповіді",
	menu: "меню",
	menutype: "тип меню",
	menutypes: "типи меню",
	func: "функція",
	funcs: "функції",
	funcparam: "параметр функції",
	funcparams: "параметри функції",
	functype: "тип функції",
	functypes: "типи функції",
	function: "функція",
	functions: "функції",
	param: "параметр",
	params: "параметри",
	parameter: "параметр",
	parameters: "параметри",
	method: "метод",
	methods: "методи",
	methodparam: "параметр методу",
	methodparams: "параметри методів",
	defaltvalue: "значення по замовчуванню",
	property: "властивість",
	properties: "властивості",
	SettlementNotice: "страхове повідомлення",
	SettlementNotices: "страхові повідомлення",
	ChatCategory: "категорія чату",
	ChatCategories: "категорії чату",

	token: "токен",
	text: "text",
	photo: "photo",
	audio: "audio",
	sticker: "sticker",
	video: "video",
	animation: "animation",
	voice: "voice",
	location: "location",
	venue: "venue",
	media: "media",

	caption: "заголовок",
	title: "назва",
	firstName: "им'я",
	middleName: "по батькові",
	lastName: "прізвище",
	phoneNumber: "номер телефону",
	disableNotification: "вимкнути сповіщення",
	onetime: "один раз",
	resize: "змінити розмір",
	hidden: "сховати",
	
	//Keyboard
	keyboard: "клавіатура",
	keyboards: "клавіатури",
	keyboardtype: "тип клавіатури",
	keyboardtypes: "типи клавіатур",
	keyboardbutton: "кнопка клавіатури",
	keyboardbuttons: "кнопки клавіатури",
	tableAdd: "додати таблицю",
	tableRemove: "видалити таблицю",
	tableRefresh: "оновити таблицю",
	tableRowAddBefore: "додати рядок таблиці перед",
	tableRowAddAfter: "додати рядок таблиці після",
	tableRowRemove: "видалити рядок таблиці",
	tableColAddBefore: "додати колонку таблиці перед",
	tableColAddAfter: "додати колонку таблиці після",
	tableColRemove: "видалити колонку таблиці",
	tableColMoveLeft: "змістити колонку таблиці ліворуч",
	tableColMoveRight: "змістити колонку таблиці праворуч",
	tableRowMoveUp: "змістити рядок таблиці вверх",
	tableRowMoveDown: "змістити рядок таблиці вниз",
	InlineKeyboardMarkup: "Inline Keyboard Markup",
	ReplyKeyboardMarkup: "Reply Keyboard Markup",
	ReplyKeyboardRemove: "Reply Keyboard Remove",
	buttonsproperties: "властивості кнопки",

	//Sentences
	"Are you sure you want to delete this record?": "Ви впевнені, що хочете видалити запис?",

	row: "рядок",
	rows: "рядки",
	column: "колонка",
	columns: "колонки",

	//homepage.banner
	cameraoff: "На вашому пристрої доступ до камери заблоковано. В такому режимі ви можете перевіряти поліси, шляхом введення вручну номеру полісу або цифр зі штрих-коду.",

	stopscan: "зупинити сканування",
	startscan: "відновити сканування",

	settings: "налаштування",
	frame: "рамка",
	laser: "лазер",
	sound: "звук",
	soundeditor: "редактор звукових сигналів",
	volume: "гучність",
	frequency: "частота",
	duration: "тривалість",
	beeps: {
		scan: "зчитування коду",
		success: "поліс ідентифіковано",
		failure: "поліс не ідентифіковано",
		error: "помилка",
	},

	//Attributes
	id: "id",
	code: "код",
	username: "им'я користувача",
	description: "опис",
	datecreate: "дата створення",
	datesign: "дата підписання",
	datebegin: "дата початку дії",
	dateend: "дата завершення дії",
	dateclose: "дата припинення дії",
	pib: "прізвице, ім'я, по батькові",
	telephone: "телефон",
	email: "email",
	icon: "значок",
	regexpression: "регулярний вираз",
	ordinal: "порядковий номер",
	datatype: "тип даних",
	datatypes: "типи даних",
	button: "кнопка",
	buttons: "кнопки",

persons: "фізичні особи",
person: "фізична особа",
firstname: "ім’я",
lastname: "прізвище",
surname: "прізвище",
patronymic: "по батькові",

birth: "народження",
birthDate: "дата народження",
birthPlace: "місце народження",
death: "смерть",
deathDate: "дата смерті",
deathPlace: "місце смерті",
nationality: "громадянство",
post: "посада",
personsname: "ПІБ",
organization: "організація",

sex: "стать",
male: "чоловіча",
female: "жіноча",

persons_roles: "ролі осіб",
claimant: "заявник",
owner: "власник",
holder: "власник",
driver: "водій",
previous_owners: "попередні власники",

identification: "документ, який посвідчує особу",
seria: "серія",
issuedby: "ким виданий",
dateofissue: "дата видачі",
recordno: "запис №",
dateofexpiry: "дійсний до",
documentno: "документ №",

dateOfIssue: "дата видачі",
dateOfExpiry: "дійсний до",

image: "зображення",
images: "зображення",

identificationstype: "тип документа",
identificationstypes: "типи посвідченнь особи",
passport: "паспорт",
passportCitizen: "паспорт громадянина",
passportForeign: "паспорт громадянина для виїзду за кордон",
passportDiplomatic: "дипломатичний паспорт",
passportService: "службовий паспорт",
passportSeamen: "посвідчення особи моряка",
passportCrew: "посвідчення члена екіпажу",
passportReturn: "посвідчення особи на повернення",
passportTemporary: "тимчасове посвідчення громадянина",
driverLicense: "посвідчення водія",
identityCardTravel: "посвідчення особи без громадянства для виїзду за кордон",
identityCardPermanent: "посвідка на постійне проживання",
identityCardTemporary: "посвідка на тимчасове проживання",
identityCardMigrant: "картка мігранта",
refugeeCertificate: "посвідчення біженця",
refugeeTravelDocument: "проїзний документ біженця",
identityCardAdditionalProtection: "посвідчення особи, яка потребує додаткового захисту",
identityCardGrantedAdditionalProtection: "проїзний документ особи, якій надано додатковий захист",

addresses: "адреси",
address: "адреса",
postalCode: "індекс",
сountry: "країна",
region: "область",
district: "район",
locality: "населений пункт",
street: "вулиця",
house: "будинок",
home: "будинок",
apartment: "квартира",
flat: "квартира",
latitude: "широта",
longitude: "довгота",
trackNumber: "номер траси",
trackNumbers: "номери трас",
place: "місце",
places: "місця",
contact: "контакт",
contacts: "контакти",

addressestypes: "типи адрес",
addresstype: "тип адреси",
addressResidence: "адреса проживання",
addressRegistration: "адреса реєстрації",

document: "документ",
documents: "документи",
templates: "Шаблони",
template: "Шаблон",
constructors: "Коструктори",
constructor: "Коструктор",

policies: "договори страхування",
policy: "договір страхування",

periodValidity: "строк дії",

notifications: "повідомлення",
notification: "повідомлення",
vehicles: "транспортні засоби",
vehicle: "транспортний засіб",
vehicleNumber: "номер транспортного засобу",
configuration: "конфігурація",

dateEvent: "Дата/час події",
dateNotice: "Дата/час повідомлення",
circumstance: "обставини",
informant: "заявник",
informing: "спосіб інформування",

cases: "справи",
case: "справа",

payments: "виплати",
payment: "виплата",

calendars: "календарі",
calendar: "календар",

	//-- Actions -------------------------
	download: "завантажити",
	upload: "вивантажити",

	filter: "фільтр",
	filters: "фільтри",

	history: "історія",
	histories: "історія",

	requestContact: "запит контакту",
	requestLocation: "запит локації",

	InsuranceObject: "об'єкт страхування",
	InsuranceObjects: "об'єкти страхування",
	InsuranceObjectType: "тип об'єкту страхування",
	InsuranceObjectTypes: "типи об'єктів страхування",
	InsuranceObjectProperty: "властивість об'єкту страхування",
	InsuranceObjectProperties: "властивості об'єктів страхування",

	//---------------------------
	Account: "обліковий запис",
	Accounts: "облікові записи",

	CommentType: "тип коментарію",
	CommentTypes: "типи коментаріїв",

	Court: "суд",
	Courts: "суди",
	CourtCase: "судова справа",
	CourtCases: "судові справи",
	CourtCaseAction: "процесуальна дія",
	CourtCaseActions: "процесуальні дії",
	CourtCaseActionType: "тип процесуальних дій",
	CourtCaseActionTypes: "типи процесуальних дій",
	CourtCaseComment: "коментар судової справи",
	CourtCaseComments: "коментарі судової справи",
	CourtCaseFinance: "фінанси судової справи",
	CourtCaseFinances: "фінанси судової справи",
	CourtCaseFinanceType: "тип фінансів",
	CourtCaseFinanceTypes: "типи фінансівs",
	CourtCaseHistory: "історія судової справи",
	CourtCaseHistories: "історії судової справи",
	CourtCaseInsuranceCase: "страхова справа в судовій справі",
	CourtCaseInsuranceCases: "страхові справи в судовій справі",
	CourtCaseInsuranceCaseType: "тип страхової справи в судовій справі",
	CourtCaseInsuranceCaseTypes: "типи страхової справи в судовій справі",
	CourtCaseInsuranceContract: "договір страхування в судовій справі",
	CourtCaseInsuranceContracts: "договори страхування в судовій справі",
	CourtCaseInsuranceContractType: "тип договору страхування в судовій справі",
	CourtCaseInsuranceContractTypes: "типи договорів страхування в судовій справі",
	CourtCaseJudgment: "судове рішення",
	CourtCaseJudgments: "судові рішення",
	CourtCaseJudgmentType: "тип судового рішення",
	CourtCaseJudgmentTypes: "типи судових рішень",
	CourtCaseMedia: "документ судової справи",
	CourtCaseMedias: "документи судової справи",
	CourtCaseMediaType: "тип документу судової справи",
	CourtCaseMediaTypes: "типи документів судової справи",
	CourtCaseMember: "учасник судової справи",
	CourtCaseMembers: "учасники судової справи",
	CourtCaseMemberType: "тип учасника",
	CourtCaseMemberTypes: "типи учасників",
	CourtCaseStageType: "стадія розгляду справи",
	CourtCaseStageTypes: "стадії розгляду справи",
	CourtCaseStatusType: "статус розгляду справи",
	CourtCaseStatusTypes: "статуси розгляду справи",
	CourtCaseType: "тип судової справи",
	CourtCaseTypes: "типи судової справи",
	CourtFormType: "форма судочинства",
	CourtFormTypes: "форми судочинства",
	CourtType: "тип суду",
	CourtTypes: "типи судів",
	CourtCaseDateBegin: "дата відкриття судового провадження",
	CourtCaseDateEnd: "дата закриття судового провадження",

	CurrencyType: "тип валюти",
	CurrencyTypes: "типи валют",

	Dictionary: "довідник",
	Dictionaries: "довідники",

	ImageObject: "зображення",
	ImageObjects: "зображення",
	InsuranceCase: "страхова справа",
	InsuranceCases: "страхові справи",
	InsuranceCaseComment: "коментар страхової справи",
	InsuranceCaseComments: "коментарі страхової справи",
	InsuranceCaseFinance: "фінанси страхової справи",
	InsuranceCaseFinances: "фінанси страхової справи",
	InsuranceCaseFinanceType: "тип фінансів страхової справи",
	InsuranceCaseFinanceTypes: "типи фінансів страхової справи",
	InsuranceCaseInsuranceContract: "договір страхування страхової справи",
	InsuranceCaseInsuranceContracts: "договори страхування страхової справи",
	InsuranceCaseInsuranceContractType: "тип договору страхування в страховій справі",
	InsuranceCaseInsuranceContractTypes: "типи договору страхування в страховій справі",
	InsuranceCaseHistory: "історія змін страхової справи",
	InsuranceCaseHistories: "історії змін страхової справи",
	InsuranceCaseMedia: "документ страхової справи",
	InsuranceCaseMedias: "документи страхової справи",
	InsuranceCaseMediaType: "тип документу страхової справи",
	InsuranceCaseMediaTypes: "типи документів страхової справи",
	InsuranceCaseMember: "учасник страхової справи",
	InsuranceCaseMembers: "учасники страхової справи",
	InsuranceCaseMemberType: "тип учасника страхової справи",
	InsuranceCaseMemberTypes: "типи учасника страхової справи",
	InsuranceCaseStatus: "статус страхової справи",
	InsuranceCaseStatuses: "статуси страхової справи",
	InsuranceCaseStatusType: "тип статусу страхової справи",
	InsuranceCaseStatusTypes: "типи статусів страхової справи",
	InsuranceCaseType: "тип страхової справи",
	InsuranceCaseTypes: "типи страхової справи",

	InsuranceClaim: "страхова претензія",
	InsuranceClaims: "страхові претензії",
	InsuranceClaimStatus: "статус страхової претензії",
	InsuranceClaimStatuses: "статуси страхової претензії",
	InsuranceClaimStatusType: "тип статусу страхової претензії",
	InsuranceClaimStatusTypes: "типи статусів страхової претензії",
	InsuranceClaimType: "тип страхової претензії",
	InsuranceClaimTypes: "типи страхової претензії",

	InsuranceContract: "договір страхування",
	InsuranceContracts: "договори страхування",
	InsuranceContractComment: "коментар договору страхування",
	InsuranceContractComments: "коментарі договору страхування",
	InsuranceContractFinance: "фінанси договору страхування",
	InsuranceContractFinances: "фінанси договору страхування",
	InsuranceContractFinanceType: "тип фінансів договору страхування",
	InsuranceContractFinanceTypes: "типи фінансів договору страхування",
	InsuranceContractHistory: "історія змін договору страхування",
	InsuranceContractHistories: "історії змін договору страхування",
	InsuranceContractMedia: "документ договору страхування",
	InsuranceContractMedias: "документи договору страхування",
	InsuranceContractMediaType: "тип документу договору страхування",
	InsuranceContractMediaTypes: "типи документів договору страхування",
	InsuranceContractMember: "учасник договору страхування",
	InsuranceContractMembers: "учасники договору страхування",
	InsuranceContractMemberType: "тип учасника договору страхування",
	InsuranceContractMemberTypes: "типи учасника договору страхування",
	InsuranceContractMessage: "Tellegram-повідомлення договору страхування",
	InsuranceContractMessages: "Tellegram-повідомлення договору страхування",
	InsuranceContractObject: "об’єкт страхування",
	InsuranceContractObjects: "об’єкти страхування",
	InsuranceContractObjectType: "тип об’єкту страхування",
	InsuranceContractObjectTypes: "типи об’єкту страхування",
	InsuranceContractStatusType: "Статус договору страхування",
	InsuranceContractStatusTypes: "Статуси договору страхування",
	InsuranceContractType: "тип договору страхування",
	InsuranceContractTypes: "типи договору страхування",

	InsuranceEvent: "страховий випадок",
	InsuranceEvents: "страхові випадки",
	InsuranceEventInformingType: "спосіб інформування про страховий випадок",
	InsuranceEventInformingTypes: "способи інформування про страховий випадок",
	InsuranceEventStatus: "статус страхового випадку",
	InsuranceEventStatuses: "статуси страхового випадку",
	InsuranceEventStatusType: "тип статусу страхового випадку",
	InsuranceEventStatusTypes: "типи статусів страхового випадку",
	InsuranceEventType: "тип страхового випадку",
	InsuranceEventTypes: "типи страхових випадків",

	Member: "учасник",
	Members: "учасники",
	MemberType: "тип учасники",
	MemberTypes: "типи учасників",

	Menu: "меню",
	Menuі: "меню",
	Method: "метод",
	Methods: "методи",
	MethodParam: "параметер",
	MethodParams: "параметри",
	MenuType: "тип меню",
	MenuTypes: "типи меню",

	Organization: "організація",
	Organizations: "організації",
	OrganizationAddress: "адреса організаціі",
	OrganizationAddresses: "адреси організаціі",
	OrganizationAddressType: "тип адреси організації",
	OrganizationAddressTypes: "типи адреси організації",
	OrganizationContact: "контакт організації",
	OrganizationContacts: "контакти організації",
	OrganizationContactType: "тип контакту організації",
	OrganizationContactTypes: "типи контакту організації",
	OrganizationDepartment: "підрозділ організації",
	OrganizationDepartments: "підрозділи організації",
	OrganizationDepartmentType: "тип підрозділу організації",
	OrganizationDepartmentTypes: "типи підрозділу організації",
	OrganizationEmployee: "співробітник",
	OrganizationEmployees: "співробітники",
	OrganizationEmployeeType: "тип cпівробітника",
	OrganizationEmployeeTypes: "типи cпівробітників",
	OrganizationKindType: "вид організації",
	OrganizationKindTypes: "види організацій",
	OrganizationPost: "посада",
	OrganizationPosts: "посади",
	OrganizationPostType: "тип посади",
	OrganizationPostTypes: "типи посад",
	OrganizationType: "тип організації",
	OrganizationTypes: "типи організацій",

	Person: "особа",
	Persons: "особи",
	PersonAddress: "адреса особи",
	PersonAddresses: "адреси особи",
	PersonAddressType: "тип адреси особи",
	PersonAddressTypes: "типи адрес особи",
	PersonContact: "контакт особи",
	PersonContacts: "контакти особи",
	PersonContactType: "тип контакту особи",
	PersonContactTypes: "типи контактів особи",
	PersonGenderType: "стать особи",
	PersonGenderTypes: "стать особи",

	PersonIdentitycard: "посвідчення особи",
	PersonIdentitycards: "посвідчення особи",
	PersonIdentitycardType: "тип посвідчення особи",
	PersonIdentitycardTypes: "типи посвідченнь особи",
	PersonIdentitycardMedia: "медіа посвідчення особи",
	PersonIdentitycardMedias: "медіа посвідчення особи",
	PersonIdentitycardMediaType: "тип медіа посвідчення особи",
	PersonIdentitycardMediaTypes: "типи медіа посвідчення особи",

	Place: "місце розташування",
	Places: "місця розташування",
	PlaceAddress: "поштова адреса",
	PlaceAddresses: "поштові адреси",
	PlaceCountry: "країна",
	PlaceCountries: "країни",
	PlaceDistrict: "район",
	PlaceDistricts: "райони",
	PlaceLocality: "населений пункт",
	PlaceLocalities: "населені пункти",
	PlaceLocalityType: "тип населеного пункту",
	PlaceLocalityTypes: "типи населених пунктів",
	PlaceStreetType: "тип вулиці",
	PlaceStreetTypes: "типи вулиць",
	PlaceRegion: "область",
	PlaceRegions: "області",

	PointContact: "контакт",
	PointContacts: "контакти",
	PointContactType: "тип контакту",
	PointContactTypes: "типи контактів",

	Profile: "профіль",
	Profiles: "профілі",

	Role: "роль",
	Roles: "ролі",

	Scenarium: "сценарій",
	Scenariums: "сценарії",
	ScenariumRequest: "запит сценарію",
	ScenariumRequests: "запити сценаріїв",
	ScenariumRequestButton: "кнопка запиту сценарію",
	ScenariumRequestButtons: "кнопки запиту сценарію",
	ScenariumRespond: "відповідь сценарію",
	ScenariumResponds: "відповіді сценаріїв",

	Talk: "розмова",
	Talks: "розмови",

	Vehicle: "транспортний засіб",
	Vehicles: "транспортні засоби",
	VehicleType: "тип транспортного засобу",
	VehicleTypes: "типи транспортних засобів",
	VehicleBrand: "марка",
	VehicleBrands: "марки",
	VehicleBrandModel: "модель",
	VehicleBrandModels: "моделі",
	

	stage: "стан",
	stages: "стани",
	status: "статус",
	statuses: "статуси",
	сontract: "договір",
	сontracts: "договори",
	insuranceContract: "договір страхування",
	insuranceContracts: "договори страхування",
	settlementCase: "страхова справа",
	settlementCases: "страхові справи",
	comment: "коментар",
	comments: "коментарі",
	member: "учасник",
	members: "учасники",
	finance: "фінанси",
	finances: "фінанси",
	judgment: "судове рішення",
	judgments: "судові рішення",
	subject: "тема",
	subjects: "теми",
	paymentProbability: "можливість виплати",
	paymentProbabilities: "можливість виплат",
	reserve: "резерв",
	reserves: "резерви",
	amount: "сума",
	amounts: "суми",
	currency: "валюта",
	currencies: "валюти",
	//---------------------------
	insurer: "страховик",
	insurant: "страхувальник",
	beneficiary: "вигодонабувач",

	company: "компанія",
	inn: "ІПН",

	//Rules
	rule: {
		required: "Значення поля не може бути пустим",
		mustBeSelected: "Необхідно обрати зі списку",
		lenless: "Назва має містити менше {0} символів",
		code: "Код має містити менше {0} символів",
		personsname: "Ім'я особи містить недопустимі символи",
		email: "E-mail вказано невірно",
		phone: "Номер телефону не вірний (+380961112233)",
	},

	btn: {
		previous: 'назад',
		next: 'далі',
		menu: 'меню',
		summary: 'перевірка',
	},
	
	noDataText: 'дані відсутні',

	dataIterator: {
		loadingText: 'завантаження даних...'
	},

	dataTable: {
		itemsPerPageText: ' ',
		ariaLabel: {
			sortNone: ' ',
			sortAscending: ' ',
			sortDescending: ' ',
			activateNone: ' ',
			activateAscending: ' ',
			activateDescending: ' ',
		},
		loadingText: 'Loading... Please wait',
	},

	dataFooter: {
		firstPage: ' ',
		prevPage: ' ',
		nextPage: ' ',
		lastPage: ' ',
		itemsPerPageAll: ' ',
		itemsPerPageText: ' ',
		pageText: 'page text',
	},

	datePicker: { 
		prevMonthAriaLabel: ' ',
		nextMonthAriaLabel: ' ',
		header: ' ',
	},

	carousel: {
		prev: 'попередній',
		next: 'наступний',
		ariaLabel: {
			delimiter: 'delimiter'
		}
	},

	pagination: {
		ariaLabel: {
			previous: 'previous',
			currentPage: 'currentPage',
			page: 'page',
			next: 'next',
			wrapper: 'wrapper',
			root: 'root',
		}
	},

	badge: 'badge',

	input: {
		clear: 'очистити',
		prependAction: ' ',
		appendAction: ' ',
		otp: 'otp',
	},
}